import { AttentionTypeLabel } from "./AttentionTypeLabel";
import { AvatarGrid } from "lib/constants";
import { Card, Col, Row } from "antd";
import { IconTags } from "./IconTags";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../Category/Logo";
import { RightCircleOutlined } from "@ant-design/icons";
import { getGradient } from "views/resources/theme";
import { pathOr } from "ramda";
import LocationIcon from "views/resources/icons/locationIcon.svg";
import React from "react";
import logos from "views/resources/logos/SVG";
import styled from "styled-components";

const leftColumnGrid = {
	xs: 6,
	sm: 6,
	md: 8,
	lg: 6,
	xl: 6,
	xxl: 6,
};

const rightColumnGrid = {
	xs: 18,
	sm: 18,
	md: 16,
	lg: 18,
	xl: 16,
	xxl: 16,
};

export const OfficeCard = ({ office, folder, mobile }) => {
	const {
		slug,
		name,
		options: {
			hours_message = null,
			brand,
			administrativeDeactivation = false,
		} = {},
	} = office;
	const attentionType = pathOr(
		false,
		["options", "reservations", "attention_type"],
		office
	);

	const disabled = pathOr(
		false,
		["options", "office_disable", "active"],
		office
	);
	const distance = pathOr(false, ["distance"], office);

	const disabledMessage = pathOr(
		null,
		["options", "office_disable", "message"],
		office
	);

	const location = useLocation();

	const kmDistance =
		office &&
		distance &&
		distance.distance &&
		!isNaN(distance.distance) &&
		distance.distance / 1000;
	const logo = pathOr(false, ["options", "brand", "logo"], office);
	const showLogo = pathOr(false, ["options", "brand", "show_logo"], office);

	const distanceExists = distance && distance.distance !== Infinity;
	const stringDistance = distanceExists
		? Math.floor(distance.distance) < 1000
			? `${distance.distance.toFixed(0)} ${distance.unit}`
			: `${kmDistance.toFixed(1)} ${distance.unit}`
		: "";

	/* const officeDistance = !!stringDistance || !!office.street; */

	const officeDistance = stringDistance || office.street || "";

	const distanceToShow =
		officeDistance.length > 23
			? `${officeDistance.substring(0, 23)}...`
			: officeDistance;

	const formatStrings = (string, length) => {
		if (string.trim().length >= length) {
			return `${string.trim().substring(0, length)}...`;
		}
		return string.trim();
	};

	return (
		<div title={folder ? folder : name}>
			<ConditionalLink
				folder={folder}
				to={
					folder
						? `/search${location.search}&folder=${folder}`
						: `offices/${slug}`
				}
				active={!disabled && !administrativeDeactivation}
				title={folder ? folder : name}
			>
				<StyledCard
					disabled={disabled || administrativeDeactivation}
					folder={folder}
					mobile={mobile}
				>
					<Row
						justify={mobile ? "space-between" : "space-around"}
						align="middle"
						position="relative"
					>
						{!folder && <IconTags office={office} setPosition />}
						<Col style={{ textAlign: "left" }}>
							<Logo
								size={AvatarGrid}
								src={
									showLogo
										? logo
										: logos[
												`logo_${office.category_id}_color`
										  ]
								}
							/>
						</Col>
						<Col {...rightColumnGrid}>
							<Row>
								<Col
									span={folder ? 24 : 20}
									style={{ position: `relative` }}
								>
									<StyledParagraph ellipsis={{ rows: 1 }}>
										<CardTitle
											length={
												folder
													? folder?.length
													: name?.length
											}
										>
											{folder
												? formatStrings(folder, 36)
												: formatStrings(name, 36)}
										</CardTitle>
									</StyledParagraph>
									{folder && (
										<>
											<StyledParagraph folder>
												Ver sucursales asociadas
											</StyledParagraph>
											<RightCircleOutlined
												style={{
													fontSize: mobile
														? "18px"
														: "24px",
													position: `absolute`,
													right: 10,
													top: `35%`,
												}}
											/>
										</>
									)}
								</Col>
							</Row>
							{!disabled &&
								!administrativeDeactivation &&
								!folder && (
									<>
										<Row>
											<Col>
												<AttentionTypeLabel
													attentionType={
														attentionType
													}
													mobile={mobile}
												/>
											</Col>
										</Row>
										<Row>
											<Col>
												{officeDistance ? (
													<ContainerFlex>
														<Icon
															src={LocationIcon}
														/>
														<StyledParagraph
															length={
																officeDistance.length
															}
														>
															<span
																className={
																	"distance_paragraph"
																}
																title={
																	officeDistance
																}
															>
																{formatStrings(
																	officeDistance,
																	23
																)}
															</span>
														</StyledParagraph>
													</ContainerFlex>
												) : (
													<ContainerFlex>
														<Icon
															src={LocationIcon}
														/>
														<StyledParagraph>
															<span
																className={
																	"distance_paragraph"
																}
															>
																Sin información
															</span>
														</StyledParagraph>
													</ContainerFlex>
												)}
											</Col>
										</Row>
									</>
								)}
							{(disabled || administrativeDeactivation) && (
								<ContainerOffline>
									{disabledMessage ||
										`Sucursal no disponible`}
								</ContainerOffline>
							)}
						</Col>
					</Row>
				</StyledCard>
			</ConditionalLink>
		</div>
	);
};

const ConditionalLink = ({ children, active, to }) => {
	if (active) return <Link to={to}>{children}</Link>;
	return children;
};

// for shadow effect
const StyledCard = styled(Card)`
	position: relative;
	box-shadow: ${getGradient("shadow")};
	${({ mobile }) =>
		mobile ? "margin: 0px 0px 8px 0px;" : "margin: 16px 0px;"}
	height: 116px;
	display: ${({ mobile }) => (mobile ? "flex" : "null")};
	flex-direction: ${({ mobile }) => (mobile ? "column" : "null")};
	justify-content: ${({ mobile }) => (mobile ? "center" : "null")};
	overflow: hidden;
	.ant-card-body {
		border-radius: 4px;
		${({ mobile }) => (mobile ? "padding: 9px;" : "padding: 9px;")}
		h5.ant-typography {
			${({ mobile }) => mobile && "margin: 6px;"}
		}
		.ant-typography {
			${({ folder }) => folder && "font-weight: 700; font-size: 14px;"}
		}
	}
	div.ant-typography,
	.ant-typography p {
		${({ folder }) => folder && "margin-bottom: 0px;"}
		${({ mobile }) => mobile && "margin: 6px; padding: 0px;"}
	}

	${(p) =>
		p.disabled &&
		`
	&:after {
		 position:absolute;
		 top: 0;
		 left:0;
		 width: 100%;
		 height: 100%;
		 background-color: rgba(255,255,255,0.5);
		 display: block;
		 content: " ";
	}`}

	&:hover {
		border: ${({ disabled }) => !disabled && "1px solid #9ac2ff;"};
	}
`;

const StyledParagraph = styled.div`
	font-weight: 400 !important;
	color: #595959;
	font-size: 14px;
	width: 200px;

	.distance_paragraph {
		margin-left: 8px;
		font-weight: 400;

		@media (min-width: 765px) {
			font-size: 14px;
		}
	}

	@media (max-width: 765px) {
		.title {
			font-size: 15px;
		}
		font-size: 13px;
	}
`;

const Icon = styled.img`
	@media (min-width: 765px) {
		width: 16px;
	}
`;

const CardTitle = styled.div`
	font-weight: 600;
	font-size: 16px;
	inline-size: 80%;
	overflow-wrap: break-all;
	display: flex;
	flex-wrap: wrap;
	width: 90%;
	overflow: hidden;
	text-overflow: ellipsis;
	max-height: 51px;
`;

const ContainerOffline = styled.div`
	border: 1px solid #bfbfbf;
	font-size: 10px;
	font-weight: 400;
	padding: 1px 8px;
	text-align: center;
	text-transform: uppercase;
	margin-top: 8px;
`;

const ContainerFlex = styled.div`
	display: flex;
	align-items: start;
	margin: 4px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;
